// Deutsch (de), Timer: zelfde vorm als kioskTimer.nl.ts.
export const kioskTimerDe = {
    open: 'Timer',
    openRunning: 'Timer: noch {time}',
    title: 'Timer',
    minutes: '{n} Min.',
    custom: 'Selbst wählen',
    less: 'Eine Minute weniger',
    more: 'Eine Minute mehr',
    minutesUnit: 'Minuten',
    forWhat: 'Wofür?',
    labels: {
        teeth: 'Zähne putzen',
        homework: 'Hausaufgaben',
        screen: 'Bildschirmzeit',
        cooking: 'Kochen',
    },
    start: 'Start',
    left: 'Noch {time}',
    paused: 'Pausiert',
    pause: 'Pause',
    resume: 'Weiter',
    plusOne: '+1 Min.',
    stop: 'Stopp',
    done: 'Die Zeit ist um!',
    /** Rustig, buiten het thema Kinderen. */
    doneCalm: 'Die Zeit ist um',
};
//# sourceMappingURL=kioskTimer.de.js.map